import React from 'react'
import CaptchaComponent from 'apps/Captcha'

const Captcha = ({ input, verifyCallback, captchaRef }) =>
  <CaptchaComponent input={input} verifyCallback={verifyCallback} captchaRef={captchaRef} />

export default Captcha
